import p5 from "p5"
window.p5 = p5

import { SVG } from "@svgdotjs/svg.js"
window.SVG = SVG

import Sortable from "sortablejs"
window.Sortable = Sortable

// Set username global from data attribute (was inline script)
window.username = document.getElementById("p5canvas")?.dataset?.username || null

import { Application } from "@hotwired/stimulus"
import FeedbackController from "./controllers/feedback_controller"
const stimulusApp = Application.start()
stimulusApp.register("feedback", FeedbackController)

import "./planner/edit"
